@if (!loading) {
  <app-breadcrumb
    listado="/main/emergencias/emergenciasMedicas"
    etiquetaListado="Emergencias"
    [titulo]="tituloMiga"
  ></app-breadcrumb>

  @if (emergencia) {
    <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info.
         El estado y el código van con la paleta única (estado-emergencia.ts). -->
    <header class="encabezado">
      <div class="encabezado-avatar"><mat-icon>emergency</mat-icon></div>
      <div class="encabezado-texto">
        <h1>Emergencia #{{ emergencia.codigo ?? '' }}</h1>
        <span class="encabezado-nombre">{{ situacion.label }}</span>
        <div class="encabezado-chips">
          <span
            class="em-badge"
            [style.--tono]="estado.color"
            matTooltip="Estado actual"
          >
            <mat-icon>{{ estado.icono }}</mat-icon>
            {{ estado.label }}
          </span>
          <span
            class="em-badge"
            [style.--tono]="prioridad.color"
            matTooltip="Código (prioridad)"
          >
            <mat-icon>{{ prioridad.icono }}</mat-icon>
            {{ prioridad.label }}
          </span>
        </div>
      </div>
      <div class="em-acciones">
        @if (accionesVisibles.length) {
          <button
            irxBotonIcono
            [matMenuTriggerFor]="menuAcciones"
            [disabled]="ejecutandoAccion"
            tooltip="Cambiar el estado"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menuAcciones="matMenu">
            @for (accion of accionesVisibles; track accion.label) {
              <button mat-menu-item (click)="ejecutar(accion)">
                <mat-icon [style.color]="accion.color">
                  {{ accion.icono }}
                </mat-icon>
                <span>{{ accion.label }}</span>
              </button>
            }
          </mat-menu>
        }
        @if (puedeEditar) {
          <button irxBotonIcono (click)="editar()" tooltip="Editar emergencia">
            <mat-icon>edit</mat-icon>
          </button>
        }
      </div>
    </header>

    <mat-tab-group
      [(selectedIndex)]="selectedTab"
      (selectedTabChange)="tabChanged($event)"
      class="tabs-detalle"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">info</mat-icon>
          <span>Info</span>
        </ng-template>
        <ng-template matTabContent>
          <app-detalles-emergencias-info
            [emergencia]="emergencia"
          ></app-detalles-emergencias-info>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">timeline</mat-icon>
          <span>Seguimiento</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-eventos-emergencias
            [id]="emergencia._id"
          ></app-listado-eventos-emergencias>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">attach_file</mat-icon>
          <span>Documentación</span>
        </ng-template>
        <ng-template matTabContent>
          <div class="em-documentacion">
            <app-dt-card titulo="Imágenes adjuntas" icono="photo_library">
              @if (imagenesCarrusel.length > 0) {
                <app-carrusel
                  [imagenes]="imagenesCarrusel"
                  [enableFullscreen]="true"
                ></app-carrusel>
              } @else {
                <span class="dt-muted">Sin imágenes adjuntas</span>
              }
            </app-dt-card>

            <app-dt-card titulo="Archivos adjuntos" icono="attach_file">
              <app-info-banner
                icon="cloud_done"
                message="Los cambios se guardan solos al subir, describir o quitar un archivo."
                color="blue"
                [closable]="false"
                margin="0 0 12px 0"
              ></app-info-banner>
              <app-subir-archivos
                textoBoton="Subir documentos"
                [allowMultiple]="true"
                [disabled]="!puedeSubirArchivos || guardandoArchivos"
                [archivos]="archivosSubidos"
                (archivosChange)="onArchivosChange($event)"
                [descripcion]="true"
              ></app-subir-archivos>
            </app-dt-card>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <app-empty-state
      icon="search_off"
      message="No se encontró la emergencia o no tenés permiso para verla."
    ></app-empty-state>
  }
} @else {
  <app-detalle-esqueleto
    icono="emergency"
    listado="/main/emergencias/emergenciasMedicas"
    etiquetaListado="Emergencias"
    [pestanas]="3"
  ></app-detalle-esqueleto>
}
